import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ITeeTime } from "redux/reducers/models/teetime";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseTemplateUrl = "/" + apiVersion + "/" + adminType + "/tee-sheet/template";

export interface ITeeSheetTemplate {
  id: number;
  facility_id: number;
  course_id: number;
  name: string;
  format: string;
  start_time: string;
  end_time: string;
  holes: number;
  interval: number;
  turn_time: number;
  tee_times: ITeeTime[];
  version: number;
  description: string;
  archived: boolean;
}

interface IGetTeeSheetTemplate {
  id?: number;
  extended?: boolean;
  archived?: boolean;
}

interface IGetTeeSheetTemplateResponse extends IAPIResponse {
  data: ITeeSheetTemplate[];
}

export interface IIntervalSection {
  start_time: string;
  end_time: string;
  interval_1: number;
  interval_2: number;
}

interface IPostTeeSheetTemplate {
  course_id: number;
  holes: number;
  name: string;
  format: string;
  start_time: string;
  end_time: string;
  interval: number;
  turn_time: number;
  interval_sections: Array<IIntervalSection>;
  size: number;
}

export interface ITeeTimeBookingCategoryUpdate extends ITeeTime {
  booking_category_ids?: number[];
}

interface IPutTeeSheetTemplate {
  id: number;
  name: string;
  tee_times: ITeeTimeBookingCategoryUpdate[];
  description: string;
  increment_version?: boolean;
}

interface IPutApplyShotgun {
  id: number;
  shotgun_template_id: number;
  start_time: string;
  duration: number;
  lead_time: number;
  division_id: number;
  turn_division_id: number;
  tournament_id?: number;
  league_id?: number;
  booking_category_ids?: Array<number>;
}

// GET Tee Sheet Template
export async function GetTeeSheetTemplate(
  params: IGetTeeSheetTemplate,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IGetTeeSheetTemplateResponse> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template"), params, useGlobalLoader, token);
}

// DELETE Shotgun Template
export async function RemoveShotgunTemplate(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/remove"), params, useGlobalLoader);
}

export async function PostTeeSheetTemplate(params: IPostTeeSheetTemplate, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template"), params, useGlobalLoader);
}

export async function PostDuplicateTemplate(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/duplicate"), params, useGlobalLoader);
}

export async function PutTeeSheetTemplate(params: IPutTeeSheetTemplate, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template"), params, useGlobalLoader);
}

export async function PutApplyShotgunTeeSheetTemplate(params: IPutApplyShotgun, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/apply-shotgun"), params, useGlobalLoader);
}

export async function PutRemoveShotgunTeeSheetTemplate(params: {id: number; shotgun_application_id: number}, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/remove-shotgun"), params, useGlobalLoader);
}

export async function ArchiveTeeSheetTemplate(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/archive"), params, useGlobalLoader);
}

export async function DeleteTeeSheetTemplate(params: IDeleteTeeSheetTemplate, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template"), params, useGlobalLoader);
}

export async function GetTeeSheetTemplatePrint(params: { id: number }, useGlobalLoader: boolean) {
  return await APIGet(baseTemplateUrl + "/print", params, useGlobalLoader);
}
